<template>
  <v-app style="min-height: unset !important">
    <div class="w-full h-full overflow-hidden">
      <div class="text-3xl">Test Result Report Per Date Range</div>
      <div class="w-full flex flex-row gap-2 overflow-hidden">
        <div
          class="w-[240px] max-w-[240px] h-full flex flex-col px-3 py-2 border-r-2 border-neutral-300"
        >
          <div>Panels</div>
          <div v-if="!isLoading" class="w-full h-full">
            <v-radio-group
              v-model="selectedPanel"
              @change="showResult()"
              column
            >
              <v-radio
                v-for="panel in panels"
                :key="panel.id"
                :label="panel.title"
                :value="panel.id"
              ></v-radio>
            </v-radio-group>
            <!-- <div v-for="panel in panels" :key="panel.id">
            
          </div> -->
          </div>
        </div>
        <div class="w-full mag h-full flex flex-col gap-3 overflow-hidden">
          <div class="w-full pt-3 flex flex-row overflow-hidden">
            <div class="w-full max-w-xs">
              <v-dialog
                ref="dialog"
                v-model="modal"
                :return-value.sync="dates"
                persistent
                width="290px"
                class="max-w-32"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    style="max-height: 40px; width: 250px"
                    v-model="dateRangeText"
                    label="Date Range"
                    prepend-icon="mdi-calendar"
                    readonly
                    outlined
                    dense
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker range v-model="dates" scrollable>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="modal = false">
                    Cancel
                  </v-btn>
                  <v-btn text color="primary" @click="$refs.dialog.save(dates)">
                    OK
                  </v-btn>
                </v-date-picker>
              </v-dialog>
            </div>
            <div class="flex flex-row gap-3 items-center justify-end">
              <v-btn color="primary" @click="generateReport()" elevation="0"
                >Generate Report</v-btn
              >
              <v-btn color="primary" @click="exportReport()" elevation="0" icon>
                <v-icon left>mdi-export</v-icon>
              </v-btn>
            </div>
          </div>
          <div
            class="w-full flex flex-row items-center justify-center p-5"
            v-if="isLoading"
          >
            <v-progress-circular
              indeterminate
              color="primary"
              class="w-full"
            ></v-progress-circular>
          </div>
          <div class="w-full h-full overflow-hidden" v-else>
            <!-- <table-page
            :headers="headers"
            :items="reportDatas"
            :rowCount="25"
            :hasActions="true"
          /> -->
            <v-simple-table v-if="reports">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th
                      class="text-left"
                      v-for="header in reports.headers"
                      :key="header.text"
                    >
                      {{ header.title }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, index) in reports.data" :key="index">
                    <td v-for="item in row" :key="item.key">
                      {{ item.value }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </div>
      </div>
    </div>
  </v-app>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from "vuex";

import fileDownload from "js-file-download";

import TablePage from "../../components/TablePage.vue";
export default {
  name: "WeeklyBreastCancerReport",
  components: {
    TablePage,
  },
  mounted() {
    this.refresh();
    var today = new Date();
    var last7Days = new Date(today.setDate(today.getDate() - 7));
    this.dates = [
      last7Days.toISOString().substr(0, 10),
      new Date().toISOString().substr(0, 10),
    ];
  },
  data: () => ({
    title: "Test Result Report Per Date Range",
    dates: ["2019-09-10", "2012-09-20"],
    modal: false,
    headers: [],
    reportDatas: [],
    reports: null,
    isLoading: false,

    orders: [],
    orderedPanels: [],
    orderedTests: [],
    orderedTestResults: [],
    panelTests: [],
    selectedPanel: null,
  }),
  computed: {
    dateRangeText() {
      return this.dates.join(" ~ ");
    },
    panels() {
      const seen = new Set();
      return this.panelTests
        .map((panelTest) => ({
          id: panelTest.panel.id,
          title: panelTest.panel.title,
        }))
        .filter((panel) => {
          if (seen.has(panel.id)) return false;
          seen.add(panel.id);
          return true;
        })
        .sort((a, b) => a.title.localeCompare(b.title));
    },
  },
  methods: {
    ...mapActions([
      "getPanelsByQuery",
      "getLIMSOrdersByQuery",
      "getLIMSOrderedPanelsByQuery",
      "getPanelTestsByQuery",
      "getLIMSOrderedTestsByQuery",
      "getLIMSOrderedTestResultsByQuery",

      // "setSelectedCollectionProtocol",
    ]),
    ...mapMutations(["setSelectedCollectionProtocol"]),
    refresh() {
      this.isLoading = true;

      this.getPanelTestsByQuery()
        .then((response) => {
          console.log("Panel Tests fetched successfully:", response);
          this.panelTests = response;
        })
        .catch((error) => {
          console.error("Error fetching panels:", error);
        });

      this.getLIMSOrdersByQuery()
        .then((response) => {
          console.log("LIMS Orders fetched successfully:", response);

          const orders = response;

          let promises = [];
          orders.forEach((order) => {
            promises.push(
              this.getLIMSOrderedPanelsByQuery({
                orderId: order.id,
              })
            );
          });

          Promise.all(promises)
            .then((responses) => {
              console.log(
                "LIMS Ordered Panels fetched successfully:",
                responses,
                responses.flat()
              );

              const orderedPanels = responses.flat();
              let testPromises = [];
              orderedPanels.forEach((orderedPanel) => {
                testPromises.push(
                  this.getLIMSOrderedTestsByQuery({
                    orderId: orderedPanel.limsOrderID,
                    orderedPanelId: orderedPanel.id,
                  })
                );
              });

              Promise.all(testPromises)
                .then((testResponses) => {
                  console.log(
                    "LIMS Ordered Tests fetched successfully:",
                    testResponses.flat()
                  );

                  const orderedTests = testResponses.flat();
                  // getLIMSOrderedTestResultsByQuery
                  let testResultPromises = [];
                  orderedTests.forEach((orderedTest) => {
                    testResultPromises.push(
                      this.getLIMSOrderedTestResultsByQuery({
                        orderId: orders.find(
                          (order) =>
                            orderedPanels.find(
                              (panel) =>
                                panel.id === orderedTest.limsOrderedPanelID
                            ).limsOrderID === order.id
                        ).id,
                        orderedPanelId: orderedTest.limsOrderedPanelID,
                        orderedTestId: orderedTest.id,
                      })
                    );
                  });

                  Promise.all(testResultPromises)
                    .then((testResultResponses) => {
                      console.log(
                        "LIMS Ordered Test Results fetched successfully:",
                        testResultResponses.flat()
                      );

                      this.orders = orders;
                      this.orderedPanels = orderedPanels;
                      this.orderedTests = orderedTests;
                      this.orderedTestResults = testResultResponses.flat();
                      this.isLoading = false;
                    })
                    .catch((error) => {
                      console.error(
                        "Error fetching LIMS Ordered Test Results:",
                        error
                      );
                    });
                })
                .catch((error) => {
                  console.error("Error fetching LIMS Ordered Tests:", error);
                });
            })
            .catch((error) => {
              console.error("Error fetching LIMS Ordered Panels:", error);
            });
        })
        .catch((error) => {
          console.error("Error fetching LIMS Orders:", error);
        });
    },
    showResult() {
      console.log("Selected Panel ID:", this.selectedPanel);

      console.log("Orders:", this.orders);
      console.log("Ordered Panels:", this.orderedPanels);
      console.log("Ordered Tests:", this.orderedTests);
      console.log("Ordered Test Results:", this.orderedTestResults);

      let orderedPanels = this.orderedPanels.filter(
        (panel) => panel.panelID === this.selectedPanel
        //  &&
        // check if the enabledDate is within the selected date range
        // new Date(panel.enabledDate) >= new Date(this.dates[0]) &&
        // new Date(panel.enabledDate) <= new Date(this.dates[1])
      );

      let orderedTests = this.orderedTests.filter((test) =>
        orderedPanels.some((panel) => panel.id === test.limsOrderedPanelID)
      );

      console.log("Filtered Ordered Panels:", orderedPanels);
      console.log("Filtered Ordered Tests:", orderedTests);
      console.log("orderedTestResults:", this.orderedTestResults);

      let tempHeaders = [
        {
          title: "Serial Number",
          text: "serialNumber",
          hasData: false,
          data: null,
        },
        {
          title: "Sample ID",
          text: "sampleID",
          hasData: false,
          data: null,
        },
      ];
      tempHeaders.push(
        // ...this.panelTests.map((panelTest) => ({
        //   title: panelTest.test.abbreviation,
        //   hasData: true,
        //   data: panel,
        // }))
        ...this.panelTests
          .filter((panelTest) => panelTest.panel.id === this.selectedPanel)
          .map((panelTest) => ({
            title: panelTest.test.abbreviation,
            text: panelTest.test.abbreviation,
            hasData: true,
            testId: panelTest.test.id,
          }))
      );

      tempHeaders.push({
        title: "Remarks",
        text: "remarks",
        hasData: false,
        data: null,
      });

      tempHeaders.push({
        title: "Ordered Date",
        text: "orderedDate",
        hasData: false,
        data: null,
      });

      console.log("Temp Headers:", tempHeaders);

      let data = [];
      orderedPanels.forEach((orderedPanel) => {
        console.log("Ordered Panel:", orderedPanel);

        let order = this.orders.find(
          (order) => order.id === orderedPanel.limsOrderID
        );

        let rowData = [
          {
            key: "serialNumber",
            value: orderedPanels.indexOf(orderedPanel) + 1,
          },
          {
            key: "sampleID",
            value: order.sampleID,
          },
        ];

        this.panelTests
          .filter((panelTest) => panelTest.panel.id === this.selectedPanel)
          .forEach((panelTest) => {
            let orderedTest = orderedTests.find(
              (orderedTest) =>
                orderedTest.limsOrderedPanelID === orderedPanel.id &&
                orderedTest.testID === panelTest.test.id
            );

            console.log(
              "Ordered Test for Panel Test:",
              panelTest.test.abbreviation,
              orderedTest
            );

            if (orderedTest) {
              let orderedTestResult = this.orderedTestResults.find(
                (result) => result.limsOrderedTestID === orderedTest.id
              );

              if (orderedTestResult) {
                rowData.push({
                  key: panelTest.test.abbreviation,
                  value: orderedTestResult.result,
                });
              } else {
                rowData.push({
                  key: panelTest.test.abbreviation,
                  value: "No Result",
                });
              }
            } else {
              rowData.push({
                key: panelTest.test.abbreviation,
                value: "Not Ordered",
              });
            }
          });

        let tempOrderedTests = orderedTests.filter(
          (orderedTest) => orderedTest.limsOrderedPanelID === orderedPanel.id
        );

        rowData.push({
          key: "remarks",
          value: tempOrderedTests
            .filter((orderedTest) => orderedTest.comment)
            .map((orderedTest) => orderedTest.comment || "")
            .join(", "),
        });

        rowData.push({
          key: "orderedDate",
          value: new Date(orderedPanel.enabledDate).toLocaleDateString(),
        });

        data.push(rowData);
      });

      console.log("Report Data:", data);
      this.reports = {
        headers: tempHeaders,
        data: data,
      };
    },
    exportReport() {
      console.log("Export Report");
      let csvString = "";
      csvString += this.reports.headers.map((x) => x.title).join(",") + "\n";
      this.reports.data.forEach((row) => {
        let rowText = "";
        row.forEach((item, index) => {
          if (index > 0) rowText += ",";
          rowText += `"${item.value ? item.value : ""}"`;
        });

        csvString += rowText + "\n";
      });
      // console.log("csvString >>>>>>>>>>>>", csvString);
      //   this.downloadCSV(csvString, "data.csv");
      fileDownload(csvString, this.title + ".csv");
    },
  },
};
</script>
